import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { numberToWords as convertNumberToWords } from 'src/app/services/number-to-words.util';

@Injectable({
  providedIn: 'root'
})
export class SharedFundDataService {
  private fundList: any[] | null = null;
private profilename: string | null = null;

  setFundList(list: any[]) {
    this.fundList = list;
  }
  setprofilename(name: any) {
    this.profilename = name;
  }
  getFundList(): any[] | null {
    return this.fundList;
  }
   getprofilename(): any {
    return this.profilename;
  }
  hasFundList(): boolean {
    return this.fundList !== null;
  }
 
hasprofilename(): boolean {
  return this.profilename !== null;
}
   clearFundList() {
    this.fundList = null;
    this.profilename=null;
  }
   private reloadSubject = new Subject<void>();

  triggerReload() {
    this.reloadSubject.next();  // emit an event
  }

  getReloadObservable() {
    return this.reloadSubject.asObservable();
  }
formatNumber(value: string | number): string {
  if (value === null || value === undefined || value === '') return '';

  let str = value.toString().replace(/,/g, '');
  let x = str.split('.');
  let lastThree = x[0].substring(x[0].length - 3);
  let otherNumbers = x[0].substring(0, x[0].length - 3);

  if (otherNumbers !== '') {
    lastThree = ',' + lastThree;
  }

  let result =
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + lastThree;

  if (x.length > 1) {
    result += '.' + x[1];
  }

  return result;
}


  // Convert number to words (Indian system)
  numberToWords(num: number): string {
    return convertNumberToWords(num, '');
  }

  // Combined helper: returns formatted + words
  processAmount(value: number) {
    return {
      raw: value,
      formatted: this.formatNumber(value),
      inWords: this.numberToWords(value) 
    };
  }
  // ── Workflow status cache ─────────────────────────────────
private workflowStatus: any[]      = [];
private folioWorkflowStatus: any[] = [];

hasWorkflowStatus(): boolean          { return this.workflowStatus.length > 0; }
setWorkflowStatus(data: any[]): void  { this.workflowStatus = data; }
getWorkflowStatus(): any[]            { return this.workflowStatus; }
clearWorkflowStatus(): void           { this.workflowStatus = []; }

hasFolioWorkflowStatus(): boolean          { return this.folioWorkflowStatus.length > 0; }
setFolioWorkflowStatus(data: any[]): void  { this.folioWorkflowStatus = data; }
getFolioWorkflowStatus(): any[]            { return this.folioWorkflowStatus; }
clearFolioWorkflowStatus(): void           { this.folioWorkflowStatus = []; }
}
